export class CoreEntity {
  constructor(){
  }
}